import React, { createContext, useContext, useEffect, useState } from "react";
import ReportDidService from "../services/ReportdidService";
import ReportAutodialerService from "../services/ReportAutodialerService";
import ReportHistoryServices from "../services/ReporthistoryService";
import DashboardService from "../services/DashboardService";
import NumberPoolService from "../services/NumberPoolService";
import CustomerServices from "../services/CustomerService";
import ReportSmsService from "../services/ReportSmsService";
import { useUserToken } from "./UserTokenContext";
import { useToast } from "./ToastContext";
import { usePreLoaderContext } from "./PreloaderContext";
import asciiDecode from "../utils/crypto";
import DidServices from "../services/DidService";
import ExtensionServices from "../services/ExtensionService";
import ReportExtensionServices from "../services/ReportextensionService";

const DownloadContext = createContext();

export const DownloadProvider = ({ children }) => {
  const { userID, userToken, account, userLang, languageData } = useUserToken();
  const AICLanguage = languageData[userLang];
  const { showToast } = useToast();
  const { setPreLoaderVisible } = usePreLoaderContext();

  //data,nodata,loading
  const [downloadStatus, setDownloadStatus] = useState("nodata");
  const [downloadUrl, setDownloadUrl] = useState("");

  const [isPolling, setIsPolling] = useState(false);
  const [pollingId, setPollingId] = useState(null);

  const getReportService = (value) => {
    switch (value) {
      case "reportDidService":
        return ReportDidService;
      case "reportAutoDialer":
        return ReportAutodialerService;
      case "reportHistory":
        return ReportHistoryServices;
      case "reportSmsAll":
        return ReportSmsService;
      case "numberpoolService":
        return NumberPoolService;
      case "reportSipService":
        return ReportExtensionServices;
      case "downloadCustomer":
        return CustomerServices;
      case "dids":
        return DidServices;
      case "extension":
        return ExtensionServices;
      default:
        return null;
    }
  };

  function downloadAllData(service, urlData) {
    setPreLoaderVisible(true);
    setDownloadStatus("loading");

    getReportService(service)
      .downloadAll(urlData)
      .then((response) => {
        setPreLoaderVisible(false);
        showToast(
          {
            title: AICLanguage.preparing_file,
            text:
              response.data.Response.id +
              " " +
              AICLanguage.your_file_is_being_prepared_you_can_track_the_download_status_from_the_status_bar_at_the_top_of_the_screen,
          },
          "warning-toast",
        );
        setIsPolling(true);
        setPollingId(response.data.Response.id);
        // setDownloadUrl(response.data.Response.CSVFilePath);
      })
      .catch((error) => {
        setPreLoaderVisible(false);
        showToast(
          {
            title: AICLanguage.preparing_file,
            text: AICLanguage.the_file_could_not_be_downloaded_please_try_again,
          },
          "error-toast",
        );
        console.error(error);
        // setIsError(true);
      });
    // }
  }

  function downloadDetailData(service, urlData) {
    setPreLoaderVisible(true);
    setDownloadStatus("loading");

    getReportService(service)
      .downloadDetail(urlData)
      .then((response) => {
        setPreLoaderVisible(false);
        showToast(
          {
            title: AICLanguage.preparing_file,
            text:
              response.data.Response.id +
              " " +
              AICLanguage.your_file_is_being_prepared_you_can_track_the_download_status_from_the_status_bar_at_the_top_of_the_screen,
          },
          "warning-toast",
        );
        setIsPolling(true);
        setPollingId(response.data.Response.id);
        // setDownloadUrl(response.data.Response.CSVFilePath);
      })
      .catch((error) => {
        setPreLoaderVisible(false);
        showToast(
          {
            title: AICLanguage.preparing_file,
            text: AICLanguage.the_file_could_not_be_downloaded_please_try_again,
          },
          "error-toast",
        );
        console.error(error);
        // setIsError(true);
      });
    // }
  }

  const getDocument = async (id) => {
    try {
      const response = await DashboardService.getDocument({
        accountcode: account.acc_accountcode,
        token: userToken,
        userid: userID,
        id: id,
      });

      // Veriyi kontrol et
      // console.log("Raw response:", response.data.Response.Data);

      if (response.data.Response.Status === "Success") {
        // Base64 içerik al

        // console.log("şifreli data -->", response);
        const decryptReportData = asciiDecode(response.data.Response.Data);
        // console.log("decryptReportData -->", decryptReportData);
        // const base64Data = response.data.Response.FileData;
        setDownloadUrl(decryptReportData.FileData);
        setDownloadStatus("data");
        // Dosya indir
        // downloadFile(decryptReportData);
      } else {
        console.error("Dosya oluşturulamadı.");
      }
    } catch (error) {
      console.error("getDocument Hata:", error);
      setIsPolling(false);
    }
  };

  useEffect(() => {
    if (!isPolling || !pollingId) return;

    const interval = setInterval(() => {
      getDocument(pollingId);
    }, 10000);

    return () => clearInterval(interval);
  }, [isPolling, pollingId]);

  const value = {
    downloadAllData,
    downloadDetailData,
    downloadStatus,
    setDownloadStatus,
    downloadUrl,
    setDownloadUrl,
    getDocument,
    pollingId,
    setIsPolling,
    setPollingId,
  };

  return (
    <DownloadContext.Provider value={value}>
      {children}
    </DownloadContext.Provider>
  );
};

export const useDownload = () => useContext(DownloadContext);
